export const config = {
  IMG_HOST: process.env.VUE_APP_IMG_HOST,
};
